import { lazy } from 'react';
 
export const routes = [
  {
    path: "/admin",
    exact: true,
    component: lazy(() => import("./components/Admin")),
    name: "Admin"
  },
  {
    path: "/support",
    exact: true,
    component: lazy(() => import("./components/Support")),
    name: "Support"
  }
];



